<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Конструктор бота</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте настроим вашего бота в&nbsp;Telegram.</p>

            <p>
              Пока интеграция доступна только с&nbsp;Telegram. В&nbsp;разработке находится подключение к&nbsp;Instagram,
              Snapchat и&nbsp;Facebook Messenger.
            </p>

            <p>В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Бот&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>На&nbsp;открывшейся странице выберите в&nbsp;меню слева раздел Telegram.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="osnovnye-nastroiki"
            class="typography__headline2"
          >
            Основные настройки
          </FaqArticlesBlockHeading>

          <p>На&nbsp;открывшейся странице выберите в&nbsp;меню слева раздел &laquo;Основные&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Слева находится вся основная информация о&nbsp;боте&nbsp;&mdash; название, юзернейм, описание, токен
            и&nbsp;возможность заменить токен и&nbsp;удалить бота.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;описании бота можно задать текст сообщения, появляющегося при первом заходе в&nbsp;бот.</p>

            <p>После заполнения текста сообщения нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>При желании заменить токен увидите окно, куда нужно будет ввести новый токен.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>При желании удалить бота увидите окно, где нужно будет ввести пароль от&nbsp;аккаунта.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="soobshheniya-i-otvety"
            class="typography__headline2"
          >
            Сообщения и ответы
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;Сообщения и&nbsp;ответы&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-8.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;приветственном сообщении можно задать текст сообщения, появляющегося при начале работы
              с&nbsp;ботом.
            </p>

            <p>После заполнения текста сообщения нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-9.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;ответе на&nbsp;неизвестное сообщение можно задать текст сообщения, появляющееся если отправить
              в&nbsp;бот неизвестную команду.
            </p>

            <p>После заполнения текста сообщения нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-10.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;ответе на&nbsp;призыв менеджера можно задать текст сообщения, появляющееся если в&nbsp;боте позвать
              менеджера.
            </p>

            <p>После заполнения текста сообщения нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-11.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;ответе на&nbsp;призыв менеджера в&nbsp;тихом режиме можно задать текст сообщения, появляющееся если
              в&nbsp;боте позвать менеджера.
            </p>

            <p>Тихий режим устанавливается в&nbsp;чате, когда нет возможности отвечать клиентам.</p>

            <p>После заполнения текста сообщения нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-12.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="komandy"
            class="typography__headline2"
          >
            Кнопки
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;Кнопки&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-13.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;главной кнопке открытия сайта есть текст, который можно изменить.</p>

            <p>После заполнения текста сообщения нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-14.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;кнопке быстрого перехода к&nbsp;заказам и&nbsp;записям есть текст, который можно изменить.</p>

            <p>После заполнения текста сообщения нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-15.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;кнопке призыва менеджера есть текст, который можно изменить.</p>

            <p>После заполнения текста сообщения нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-16.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="vkluchenie-bota"
            class="typography__headline2"
          >
            Включение бота
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              После настройки бота, вы&nbsp;можете его включить и&nbsp;перейти по&nbsp;ссылке для просмотра изменений
            </p>

            <p>Для этого нажмите &laquo;Включить&raquo; на&nbsp;главной странице настройки бота.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-bota-17.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Как настроить бот разобрались. Самое время перейти к&nbsp;<BaseLink
              class="ui-link-secondary"
              to="/faq/articles/uvedomleniya-klienta"
              >настройке уведомлений клиента </BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Бот и&nbsp;интеграции",
    url: "/faq/categories/bot-i-integratsii",
  },
  {
    name: "Конструктор бота",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Основные&nbsp;настройки",
    url: "osnovnye-nastroiki",
  },
  {
    name: "Сообщения&nbsp;и&nbsp;ответы",
    url: "soobshheniya-i-otvety",
  },
  {
    name: "Кнопки",
    url: "komandy",
  },
  {
    name: "Включение&nbsp;бота",
    url: "vkluchenie-bota",
  },
];

const relatedArticles = [
  {
    name: "Бот для клиентов",
    slug: "bot-dlya-klientov",
  },
  {
    name: "Уведомления клиента",
    slug: "uvedomleniya-klienta",
  },
  {
    name: "Подключение к&nbsp;Telegram",
    slug: "podklyuchenie-k-telegram",
  },
];

useSeoMeta({
  title: "Конструктор бота",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
